import { render, staticRenderFns } from "./MsgElementTip.vue?vue&type=template&id=3884aa84&scoped=true"
import script from "./MsgElementTip.vue?vue&type=script&lang=js"
export * from "./MsgElementTip.vue?vue&type=script&lang=js"
import style0 from "./MsgElementTip.vue?vue&type=style&index=0&id=3884aa84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884aa84",
  null
  
)

export default component.exports